module.exports = __webpack_public_path__ + "static/media/4. 5 & 8 ltr Sprayer.b0521958.jpg";